import { Cache } from '@urql/exchange-graphcache';
import { GQFootprintsForFootprintListQuery } from '../../generated/graphql-operations';
import { FootprintsForFootprintListDocument } from '../../generated/urql';
import { updateFootprintsAfterGenerateFootprintMutation } from './updateCacheAfterGenerateFootprintMutation';

/**
 * Shared cache invalidation logic for footprint generation mutations.
 * This function handles the common cache updates needed when a footprint
 * generation is started, regardless of whether it's V1 or JAD (Just Add Data).
 */
export function updateCacheAfterFootprintGeneration(
  cache: Cache,
  footprintId: string,
  footprintAssemblyRunId: string | undefined
): void {
  // Invalidate queries that track footprint generation status
  cache.invalidate('Query', 'latestFootprintAssemblyRun');
  cache.invalidate('Query', 'numGeneratingFootprintsForOrg');

  if (!footprintAssemblyRunId) {
    return;
  }

  // We have a footprint that's generating a new snapshot - let's update our
  // cached objects that reference it

  // 1. For list of footprints - reuse existing helper
  cache.updateQuery(
    {
      query: FootprintsForFootprintListDocument,
    },
    (data: GQFootprintsForFootprintListQuery | null) =>
      updateFootprintsAfterGenerateFootprintMutation(data, footprintId)
  );

  // 2. For footprint detail page + footprint overview
  cache.invalidate('Query', 'footprintSnapshotInDashboard');
  cache.invalidate('Query', 'footprintAnalysis');
}
